import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import { useContext } from 'react';
import { UserContext } from '../assets/contexts/userContext';
import { getEmployeeColor } from '../constants/employeeColors';
import { STATUS_COLORS } from '../constants/statusColors';
import * as endPoints from '../assets/js/endpoints';
import { Modal, Box, Button, TextField, Card, Typography, Chip, Autocomplete } from '@mui/material';
import '../css/global.css';
import '../css/calendar-home.css';
import '../css/calendar-intranet.css';
import { useNotification } from '../assets/contexts/notificationContext';
import Loader from '../components/loader';
// import { UserContexto } from '../app'; // Suponiendo que ya tienes el contexto del usuario

const Calendar = ({ showActivities = false, variant = 'intranet' }) => {
    const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [services, setServices] = useState([]);
  const [clients, setClients] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [infoEvent, setInfoEvent] = useState(null);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [registerForm, setRegisterForm] = useState({
    name: '',
    last_name: '',
    phone: '',
    email: '',
    attendees: 1,
    notes: ''
  });
  const [form, setForm] = useState({
    date: '',
    time: '',
    service_id: '',
    client_id: '',
    notes: '',
    status: 'Pendiente',
    employee_ids: [],
    type: 'appointment',
    max_attendees: '',
    end_time: '',
    notification_email: '',
    color: '#3788d8'
  });
  const [stats, setStats] = useState([]);
  const { user } = useContext(UserContext);
  // const [filteredEmployeeId, setFilteredEmployeeId] = useState(
  //   user.role === 'employee' ? user.id : null
  // );
  // Mostrar todas las citas por defecto
  const defaultFilteredId = null;
  const [filteredEmployeeId, setFilteredEmployeeId] = useState(defaultFilteredId);
  const [editingId, setEditingId] = useState(null);
  const { showNotification } = useNotification();
  const canEdit = user.isLogged && !showActivities;


  const loadEvents = async () => {
    try {
      let data;
      if (showActivities || !user.isLogged) {      
        data = await endPoints.getActivities();     
      } else {    
       data = await endPoints.getAppointments();
      }
      setEvents(data);
    } catch (_error) {    
    }
  };

  const loadOptions = async () => {
    try {
      let servicePromise = endPoints.getAllServices();
      let clientPromise = Promise.resolve([]);
      let usersPromise = Promise.resolve([]);

      if (user.isLogged) {
        if (user.role === 'employee') {
          servicePromise = endPoints.getServicesByEmployee(user.id);
          clientPromise = endPoints.getClientsByEmployee(user.id);
        } else {
          clientPromise = endPoints.getAllClients();
        }

        if (user.role === 'admin' || user.role === 'employee') {
          usersPromise = endPoints.getAllUsers();
        }
      }

      const [servs, clis, users] = await Promise.all([
        servicePromise,
        clientPromise,
        usersPromise
      ]);
      setServices(servs || []);
      if (user.isLogged) setClients(clis || []);

      if (user.isLogged && (user.role === 'admin' || user.role === 'employee')) {
        const userList = Array.isArray(users) ? users : users?.data || [];
        const excludedNames = ['Ester y Patricia', 'Admin'];
        const emps = userList.filter(u => {
          // Si el nombre está en excludedNames, lo descartamos
          if (excludedNames.includes(u.name)) {
            return false;
          }
          // Si no, mantenemos la lógica original
          const roleName = u.role || u.roles?.[0]?.name;
          // return roleName === 'employee' || u.id === user.id;
          return (roleName || u.id === user.id);
        });
        setEmployees(emps);
      }

      if (user.isLogged) {
        const stats = await endPoints.getAppointmentCounts();
        setStats(stats);
      }
    } catch (_err) {
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        if (showActivities || user.id !== null) {
          await loadEvents();
        }
        await loadOptions();
      } catch (_err) {
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [showActivities, user.role, user.id]);

  useEffect(() => {
    setFilteredEmployeeId(defaultFilteredId);
  }, [defaultFilteredId]);

  useEffect(() => {
    if (user.role === 'employee' && services.length === 1 && !form.service_id) {
      setForm(f => ({ ...f, service_id: services[0].id }));
    }
  }, [services, user.role]);

  const handleDateClick = info => {
    setForm({
      date: info.dateStr,
      time: '',
      service_id: user.role === 'employee' ? (services[0]?.id || '') : '',
      client_id: '',
      notes: '',
      status: 'Pendiente',
      employee_ids: user.role === 'admin' ? [] : [user.id],
      type: 'appointment',
      max_attendees: '',
      end_time: '',
      notification_email: '',
      color: '#3788d8',
    });
    setEditingId(null);
    setModalOpen(true);
  };

  const handleEventClick = info => {
      const ev = info.event;
      const { extendedProps } = ev;
      setForm({
        date: ev.startStr.substring(0, 10),
        time: (extendedProps.time || '').substring(0,5),
        service_id: extendedProps.service_id || '',
        client_id: extendedProps.client_id || '',
        notes: extendedProps.notes || '',
        status: extendedProps.status || 'Pendiente',
      employee_ids: (extendedProps.users || []).map(u => u.id),
      type: extendedProps.type || 'appointment',
      max_attendees: extendedProps.max_attendees || '',
      end_time: extendedProps.end_time ? extendedProps.end_time.substring(0,5) : '',
      notification_email: extendedProps.notification_email || '',
      color: extendedProps.color || '#3788d8',
    });
    setEditingId(ev.id);
    setModalOpen(true);
  };

  const handlePublicEventClick = info => {
    const ev = info.event;
    const { extendedProps } = ev;
    const serviceName = services.find(s => s.id === extendedProps.service_id)?.name || '';
    setInfoEvent({
      id: ev.id,
      type: extendedProps.type,
      date: ev.startStr.substring(0, 10),
      time: extendedProps.time || '',
      client_name: extendedProps.client_name || '',
      client_apellidos: extendedProps.client_apellidos || '',
      serviceName,
      notes: extendedProps.notes || '',
      status: extendedProps.status || '',
      max_attendees: extendedProps.max_attendees || '',
      registered_attendees: extendedProps.registered_attendees || 0,
      end_time: extendedProps.end_time || '',
      notification_email: extendedProps.notification_email || '',
      type: extendedProps.type,
    });
    setInfoOpen(true);
  };

  const handleEventClickWrapper = info => {
      const users = info.event.extendedProps.users || [];
    if (user.role === 'admin' || users.some(u => u.id === user.id)) {
      handleEventClick(info);
    } else {
      handlePublicEventClick(info);
    }
  };

  const handleChange = e => {
    let { name, value } = e.target;
    // Ensure employee_ids is always an array
    if (name === 'employee_ids' && !Array.isArray(value)) {
      value = value ? [value] : [];
    }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const payload = new FormData();
      const service = services.find(s => String(s.id) === String(form.service_id));
      const client = clients.find(c => String(c.id) === String(form.client_id));
      let employeeIds = user.role === 'admin' ? form.employee_ids : [user.id];
      // Normalize to array in case a single value sneaks in
      if (!Array.isArray(employeeIds)) {
        employeeIds = employeeIds ? [employeeIds] : [];
      }
      const employeeNames = employees.filter(e => employeeIds.includes(e.id)).map(e => e.name).join(',');
      employeeIds.forEach(id => payload.append('employee_ids[]', id));
      if (employeeNames) payload.append('employee_name', employeeNames);
      payload.append('date', form.date);
      payload.append('time', form.time.substring(0,5));
      if (form.service_id) {
        payload.append('service_id', form.service_id);
        if (service) payload.append('service_name', service.name);
      }
      if (form.type === 'appointment' && form.client_id) {
        payload.append('client_id', form.client_id);
        if (client) payload.append('client_name', client.name);
      }
      payload.append('notes', form.notes);
      payload.append('status', form.status);
      payload.append('type', user.role === 'admin' ? form.type : 'appointment');

      if (form.type === 'activity') {
        if (form.max_attendees) payload.append('max_attendees', form.max_attendees);
        if (form.end_time) payload.append('end_time', form.end_time.substring(0,5));
        if (form.notification_email) payload.append('notification_email', form.notification_email);
        if (form.color) payload.append('color', form.color);
      }

      if (editingId) {
        await endPoints.updateAppointment(editingId, payload);
        showNotification('Cita actualizada con éxito', 'success');
        loadEvents();
      } else {
        await endPoints.createAppointment(payload);
        showNotification('Cita creada con éxito', 'success');
        // const data = await endPoints.getAppointmentsByRole(user.role, user.id);
        // setEvents(data);
        await loadEvents();
      }

      setModalOpen(false);
      setEditingId(null);
    } catch (err) {
      const message =
        err.response?.data?.errors?.date?.[0] ||
        err.response?.data?.error ||
        'Error guardando cita';
      showNotification(message, 'error');
    }
  };

  const handleRegisterChange = e => {    
      const { name, value } = e.target;
      setRegisterForm({ ...registerForm, [name]: value });
  };

  const handleRegisterSubmit = async e => {
    e.preventDefault();
    try {
      await endPoints.registerActivity(infoEvent.id, registerForm);
      showNotification('Inscripción realizada', 'success');
      setRegisterOpen(false);
    } catch (error) {
      const msg = error.response?.data?.error || 'Error al inscribirse';
      showNotification(msg, 'error');
    }
  };

  const handleDelete = async () => {
    if (!editingId) return;
    try {
      await endPoints.deleteAppointment(editingId);
      setModalOpen(false);
      setEditingId(null);
      loadEvents();
      showNotification('Cita eliminada', 'success');
    } catch (_err) {
      showNotification('Error eliminando cita', 'error');
    }
  };

  const handleShare = async () => {
    if (!selectedEmployee || !editingId) return;
    try {
      await endPoints.shareAppointment(editingId, selectedEmployee);
      showNotification('Cita compartida', 'success');
      setShareOpen(false);
      setSelectedEmployee('');
      loadEvents();
    } catch (_err) {
      showNotification('Error compartiendo cita', 'error');
    }
  };

  const handleEventDidMount = info => {
    const { extendedProps } = info.event;
    const serviceName = services.find(s => s.id === extendedProps.service_id)?.name || '';
    const { client_name = '', client_apellidos = '' } = extendedProps;
    const clienteFull = [client_name, client_apellidos].filter(part => part && part !== 'null').join(' ') || 'Sin cliente';
    const parts = [];
   if (extendedProps.time) {
        const t = extendedProps.time.substring(0, 5);
        parts.push(extendedProps.type === 'activity'
          ? `Inicio: ${t}`
          : `Hora: ${t}`);
      }
      if (extendedProps.end_time) {
      const et = extendedProps.end_time.substring(0, 5);
      parts.push(`Fin: ${et}`);
    }
    // if (extendedProps.client_name) parts.push(`Cliente: ${extendedProps.client_name}`);
    if (extendedProps.type === 'appointment' && clienteFull) {parts.push(`Cliente: ${clienteFull}`);}
    if (user.id && extendedProps.users && extendedProps.users.length > 0) {
      const userNames = extendedProps.users.map(u => u.name).join(', ');
      parts.push(`Empleados: ${userNames}`);
    }
    if (serviceName) parts.push(`Servicio: ${serviceName}`);
    if (extendedProps.max_attendees) {
      parts.push(`Plazas: ${extendedProps.max_attendees}`);
      const libres = extendedProps.max_attendees - (extendedProps.registered_attendees || 0);
      parts.push(`Plazas libres: ${libres}`);
    }
    if (user.id && extendedProps.notification_email) parts.push(`Email: ${extendedProps.notification_email}`);
    if (extendedProps.notes) parts.push(`Notas: ${extendedProps.notes}`);
    info.el.title = parts.join('\n');
    const color = STATUS_COLORS[extendedProps.status] || STATUS_COLORS.Pendiente;
    info.el.style.borderLeft = `4px solid ${color}`;
  };

  const filteredEvents =
    filteredEmployeeId !== null
      ? events.filter(ev => ev.users?.some(u => u.id === filteredEmployeeId))
      : events;


  if (loading) {
    return <Loader />;
  }

  return (
    <>
    {user.id ? (
          <>
            <Helmet>
              <title>Calendario | CES</title>
              <meta
                name="description"
                content="Consulta las próximas actividades en nuestro calendario."
              />
            </Helmet>
            <div>
              {/* contenido adicional */}
            </div>
          </>
        ) : (
          ''
        )}
      <Box
        className={`${variant === 'home' ? 'home-calendar' : 'intranet-calendar'}`}

        sx={{ mx: 'auto', width: { xs: '100%', md: '100%' }, display: 'flex', flexDirection: 'column', alignItems: 'center',
         p: '2rem'}}>
     
          {variant !== 'home' && (
            <>
              <Typography variant="h4" sx={{ mb: 2 }}>
                Calendario
              </Typography>

              <Box
                sx={{
                  mt: 2,
                  mb: 2,
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 2,
                  justifyContent: 'center',
                }}
              >
                <Chip
                  key="all"
                  label="Tod@s"
                  onClick={() => setFilteredEmployeeId(null)}
                  variant={filteredEmployeeId === null ? 'filled' : 'outlined'}
                  sx={{
                    borderColor: 'primary.main',
                    bgcolor:
                      filteredEmployeeId === null ? 'primary.main' : 'transparent',
                    color: filteredEmployeeId === null ? '#fff' : 'inherit',
                  }}
                />
                {employees.map(emp => (
                  <Chip
                    key={emp.id}
                    label={emp.name}
                    onClick={() => setFilteredEmployeeId(emp.id)}
                    onDelete={
                      filteredEmployeeId !== defaultFilteredId &&
                      filteredEmployeeId === emp.id
                        ? () => setFilteredEmployeeId(defaultFilteredId)
                        : undefined
                    }
                    variant={filteredEmployeeId === emp.id ? 'filled' : 'outlined'}
                    sx={{
                      borderColor: emp.color || getEmployeeColor(emp.id),
                      bgcolor:
                        filteredEmployeeId === emp.id
                          ? emp.color || getEmployeeColor(emp.id)
                          : 'transparent',
                      color: filteredEmployeeId === emp.id ? '#fff' : 'inherit',
                    }}
                  />
                ))}
              </Box>

              <Box
                sx={{
                mb: 2,
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 2,
                  justifyContent: 'center',
                }}
              >
                {Object.entries(STATUS_COLORS).map(([st, color]) => (
                  <Box key={st} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        backgroundColor: color,
                        borderRadius: '50%',
                      }}
                    />
                    <Typography variant="body2">{st}</Typography>
                  </Box>
                ))}
              </Box>
            </>
          )}
    
    

      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        locale={esLocale}    
        height={650}
        dateClick={canEdit ? handleDateClick : null}
        eventClick={handleEventClickWrapper}
        eventDidMount={handleEventDidMount}
        events={events
          .filter(ev =>
            !filteredEmployeeId || ev.users?.some(u => u.id === filteredEmployeeId)
          )
          .map(ev => ({
             id: ev.id,
           title:
            ev.type === 'activity'
            ? ev.notes || 'Actividad'
            : `${ev.time?.substring(0, 5) ?? ''} - ${[ev.client_name, ev.client?.apellidos].filter(part => part && part !== 'null').join(' ') || 'Sin cliente'}`,
            date: ev.date,
            backgroundColor: ev.type === 'activity'
              ? ev.color || '#3788d8'
              : ev.users?.[0]?.color || getEmployeeColor(ev.users?.[0]?.id),
            classNames: [`status-${(ev.status || 'Pendiente').toLowerCase()}`],
          extendedProps: {
            time: ev.time,
            client_id: ev.client_id,
            client_name: ev.client_name,
            client_apellidos: ev.client?.apellidos,
            service_id: ev.service_id,
            notes: ev.notes,
            users: ev.users || [],
            type: ev.type,
            status: ev.status,
            max_attendees: ev.max_attendees,
            registered_attendees: ev.registered_attendees,
            end_time: ev.end_time,
            notification_email: ev.notification_email,
            color: ev.color,
          },
        }))}
      />

    
      <Modal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setEditingId(null);
        }}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        slotProps={{
        backdrop: {onClick: () => { setModalOpen(false); setEditingId(null); } }}}>
        <Card onClick={e => e.stopPropagation()}
              sx={{ p: 2, mx: 'auto', my: '10%', width: { xs: '90%', sm: '90%', md: '70%' }, maxWidth: '90%', maxHeight: '80vh', overflowY: 'auto' }}>
          <Typography variant='h6' sx={{textAlign:'center', p:2}}>{editingId ? 'Editar cita' : 'Crear cita'}</Typography>
          <Box component="form" onSubmit={handleSubmit}
               sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
            <TextField label="Fecha" name="date" type="date" value={form.date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
            <TextField label={form.type === 'activity' ? 'Hora inicio' : 'Hora'} name="time" type="time" value={form.time} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
            {form.type === 'activity' && (
              <TextField label="Hora fin" name="end_time" type="time" value={form.end_time} onChange={handleChange} InputLabelProps={{ shrink: true }} />
            )}
            {user.role === 'admin' && (
              <Autocomplete
                options={[
                  { label: 'Cita', value: 'appointment' },
                  { label: 'Actividad', value: 'activity' },
                ]}
                value={[{ label: 'Cita', value: 'appointment' }, { label: 'Actividad', value: 'activity' }]
                  .find(option => option.value === form.type) || null}
                onChange={(_event, newValue) => {
                  setForm(prev => ({ ...prev, type: newValue ? newValue.value : '' }));
                }}
                getOptionLabel={option => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={params => (
                  <TextField {...params} label="Tipo" required />
                )}
              />
            )}
            {(user.role === 'admin' || user.role === 'employee') && (
              <Autocomplete
                options={Object.keys(STATUS_COLORS)}
                value={form.status || null}
                onChange={(_event, newValue) => {
                  setForm(prev => ({ ...prev, status: newValue || '' }));
                }}
                renderInput={params => (
                  <TextField {...params} label="Estado" required />
                )}
              />
            )}
            {user.role === 'admin' && (
              <Autocomplete
                multiple
                options={employees}
                value={employees.filter(e => form.employee_ids.map(id => String(id)).includes(String(e.id)))}
                onChange={(_event, newValue) => {
                  setForm(prev => ({ ...prev, employee_ids: newValue.map(e => e.id) }));
                }}
                getOptionLabel={option => option.name}
                isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Empleados"
                    required={form.type === 'appointment' && form.employee_ids.length === 0}
                  />
                )}
              />
            )}

            {user.role === 'admin' && (
            <Autocomplete
              options={services}
              value={services.find(s => String(s.id) === String(form.service_id)) || null}
              onChange={(_event, newValue) => {
                setForm(prev => ({ ...prev, service_id: newValue ? newValue.id : '' }));
              }}
              getOptionLabel={option => option.name}
              isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
              renderInput={params => (
                <TextField {...params} label="Servicio" required />
              )}
            />
            )}
            {form.type === 'appointment' && (
              <Autocomplete
                options={clients}
                value={clients.find(c => String(c.id) === String(form.client_id)) || null}
                onChange={(_event, newValue) => {
                  setForm(prev => ({ ...prev, client_id: newValue ? newValue.id : '' }));
                }}
                getOptionLabel={option => `${option.name} ${option.apellidos}`}
                isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                renderInput={params => (
                  <TextField {...params} label="Cliente" />
                )}
              />
            )}
            {form.type === 'activity' && (
              <>
                <TextField label="Máx asistentes" name="max_attendees" type="number" value={form.max_attendees} onChange={handleChange} />                
                <TextField label="Color" name="color" type="color" value={form.color} onChange={handleChange} InputLabelProps={{ shrink: true }} sx={{ gridColumn: '1 / -1', }}  />
                <TextField label="Email de notificación" name="notification_email" type="email" value={form.notification_email} onChange={handleChange} sx={{ gridColumn: '1 / -1' }}/>
              </>
            )}
            <TextField className="full-width" label="Notas" name="notes" value={form.notes} onChange={handleChange} multiline sx={{ gridColumn: '1 / -1', }}  rows={2} />
            <Box sx={{ display: 'flex', flexWrap:'wrap', gap: 2, justifyContent: 'center', gridColumn: '1 / -1' }}>
              {editingId && (
                <Button color="error" variant="contained" onClick={handleDelete}>Eliminar</Button>
              )}
              {editingId && (user.role === 'admin' || user.role === 'employee') && (
                <Button color="info" variant="contained" onClick={() => setShareOpen(true)}>Compartir</Button>
              )}
              <Button type="submit" variant="contained">{editingId ? 'Actualizar' : 'Crear'}</Button>
            </Box>
          </Box>
        </Card>
      </Modal>
      <Modal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        slotProps={{ backdrop: { onClick: () => setShareOpen(false) } }}
      >
        <Card onClick={e => e.stopPropagation()} sx={{ p:2, m:'5% auto', width:{ xs:'90%', sm:400 } }}>
          <Typography variant='h6' sx={{ textAlign:'center', p:2 }}>Compartir Cita</Typography>
          <Box component='form' onSubmit={e => { e.preventDefault(); handleShare(); }} sx={{ display:'flex', flexDirection:'column', gap:2 }}>
            <Autocomplete
              options={employees}
              value={employees.find(emp => String(emp.id) === String(selectedEmployee)) || null}
              onChange={(_event, newValue) => setSelectedEmployee(newValue ? newValue.id : '')}
              getOptionLabel={option => option.name}
              isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
              renderInput={params => (
                <TextField {...params} label="Empleado" required />
              )}
            />
            <Box sx={{ display:'flex', gap:2, justifyContent:'center' }}>
              <Button onClick={() => setShareOpen(false)}>Cancelar</Button>
              <Button type='submit' variant='contained'>Compartir</Button>
            </Box>
          </Box>
        </Card>
      </Modal>
      <Modal
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        slotProps={{ backdrop: { onClick: () => setInfoOpen(false) } }}
      >
        <Card onClick={e => e.stopPropagation()} sx={{ p:2, m:'10% auto', width:{ xs:'90%', sm:400 } }}>
          <Typography variant='h6' sx={{ textAlign:'center', p:2 }}>Detalles de la actividad</Typography>
          <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
            <Typography><strong>Fecha:</strong> {infoEvent?.date}</Typography>
            {infoEvent?.time && <Typography><strong>Inicio:</strong> {infoEvent.time}</Typography>}
            {infoEvent?.end_time && <Typography><strong>Fin:</strong> {infoEvent.end_time}</Typography>}
            {infoEvent?.type === 'appointment' && (
              <Typography>
                <strong>Cliente:</strong> {[infoEvent.client_name, infoEvent.client_apellidos].filter(part => part && part !== 'null').join(' ') || 'Sin cliente'}
              </Typography>
            )}
            {infoEvent?.serviceName && <Typography><strong>Servicio:</strong> {infoEvent.serviceName}</Typography>}
            {infoEvent?.max_attendees && <Typography><strong>Plazas:</strong> {infoEvent.max_attendees}</Typography>}
            {infoEvent?.max_attendees && (
              <Typography><strong>Plazas libres:</strong> {infoEvent.max_attendees - (infoEvent.registered_attendees || 0)}</Typography>
            )}
            {infoEvent?.notification_email && <Typography><strong>Email:</strong> {infoEvent.notification_email}</Typography>}
            {infoEvent?.status && <Typography><strong>Estado:</strong> {infoEvent.status}</Typography>}
            {infoEvent?.notes && <Typography><strong>Notas:</strong> {infoEvent.notes}</Typography>}
            {infoEvent?.type === 'activity' && (
              <>
              {user.id ? '' : <Button sx={{ mt:2 }} variant='contained' onClick={() => setRegisterOpen(true)}>Inscribirse</Button>}
              </>
            )}
          </Box>
        </Card>
      </Modal>
      <Modal
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        slotProps={{ backdrop: { onClick: () => setRegisterOpen(false) } }}
      >
        <Card onClick={e => e.stopPropagation()} sx={{ p:2, m:'10% auto', width:{ xs:'90%', sm:400 } }}>
          <Typography variant='h6' sx={{ textAlign:'center', p:2 }}>Inscripción</Typography>
          <Box component='form' onSubmit={handleRegisterSubmit} sx={{ display:'flex', flexDirection:'column', gap:2 }}>
            <TextField label='Nombre' name='name' value={registerForm.name} onChange={handleRegisterChange} required />
            <TextField label='Apellidos' name='last_name' value={registerForm.last_name} onChange={handleRegisterChange} required />
            <TextField label='Teléfono' name='phone' value={registerForm.phone} onChange={handleRegisterChange} required />
            {/* {user.id ? '' :  */}
            <TextField label='Email' name='email' value={registerForm.email} onChange={handleRegisterChange}  />
            {/*  } */}
            <TextField label='Número de asistentes' type='number' name='attendees' value={registerForm.attendees} onChange={handleRegisterChange} required />
            <TextField label='Notas' name='notes' value={registerForm.notes} onChange={handleRegisterChange} multiline />
            <Box sx={{ display:'flex', gap:2, justifyContent:'center', mt:1 }}>
              <Button onClick={() => setRegisterOpen(false)}>Cancelar</Button>
              <Button type='submit' variant='contained'>Enviar</Button>
            </Box>
          </Box>
        </Card>
      </Modal>
      </Box>
    </>
  );
};

export default Calendar;
